export class SearchFormHandler {
    constructor() {

        this.init();
    }

    init() {
        const searchTarget = document.querySelector('.search-form');
        if (!searchTarget) return;

        this.bindSubmit();
        this.bindReset();
        this.bindTransactionChange();
        this.bindCategoryChange();
        this.triggerInitialChanges();
    }

    bindSubmit() {
        const submitBtn = document.getElementById('search-submit-btn');
        if (!submitBtn) return;

        submitBtn.addEventListener('click', (e) => {
            const targetSelector = submitBtn.getAttribute('data-form');
            const targetForm = document.querySelector(targetSelector);
            if (targetForm) targetForm.submit();
        });
    }

    bindReset() {
        const resetBtn = document.getElementById('search-reset-btn');
        if (!resetBtn) return;

        resetBtn.addEventListener('click', () => {
            const targetSelector = resetBtn.getAttribute('data-form');
            const targetForm = document.querySelector(targetSelector);
            if (!targetForm) return;

            targetForm.reset();


            document.getElementById('transaction_id')?.dispatchEvent(new Event('change'));
            document.getElementById('category_id')?.dispatchEvent(new Event('change'));
        });
    }

    showOnCatTrans() {
        document.querySelectorAll('.hide-on-transcat').forEach((el) => {
            el.classList.add('hidden', 'd-none');
        });

        const transaction = document.querySelector('input[name="transaction_id"]:checked')?.value;
        const category = document.getElementById('category_id')?.value;

        document.querySelectorAll(`.show-on-transcat-${transaction}-${category}`).forEach((el) => {
            el.classList.remove('hidden', 'd-none');
        });

        document.querySelectorAll('#search-form .hidden input').forEach((input) => {
            if (input.type === 'text') input.value = '';
            if (input.type === 'checkbox') input.checked = false;
        });
    }

    bindTransactionChange() {
        const inputs = document.querySelectorAll('input[name="transaction_id"]');
        inputs.forEach((input) => {
            input.addEventListener('change', () => {
                const value = input.value;

                document.querySelectorAll('.hide-on-transaction').forEach((el) => el.classList.add('hidden', 'd-none'));
                document.querySelectorAll('.show-on-transaction').forEach((el) => el.classList.remove('hidden', 'd-none'));
                document.querySelectorAll(`.show-on-transaction-${value}`).forEach((el) => el.classList.remove('hidden', 'd-none'));
                document.querySelectorAll(`.hide-on-transaction-${value}`).forEach((el) => el.classList.add('hidden', 'd-none'));

                this.showOnCatTrans();
            });
        });
    }

    bindCategoryChange() {
        const category = document.getElementById('category_id');
        if (!category) return;

        category.addEventListener('change', () => {
            const value = category.value;
            document.querySelectorAll('.hide-on-category').forEach((el) => el.classList.add('hidden', 'd-none'));
            document.querySelectorAll('.show-on-category').forEach((el) => el.classList.remove('hidden', 'd-none'));
            document.querySelectorAll(`.show-on-category-${value}`).forEach((el) => el.classList.remove('hidden', 'd-none'));
            document.querySelectorAll(`.hide-on-category-${value}`).forEach((el) => el.classList.add('hidden', 'd-none'));

            this.showOnCatTrans();
        });
    }

    triggerInitialChanges() {
        document.getElementById('transaction_id')?.dispatchEvent(new Event('change'));
        document.getElementById('category_id')?.dispatchEvent(new Event('change'));
    }


}
